function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
})), /*#__PURE__*/React.createElement("g", {
  id: "clock",
  transform: "translate(1236.667 138.667)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#CACDD9",
  d: "M-1224.7-136.7c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S-1230.2-136.7-1224.7-136.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_256"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#474A57",
  d: "M-1220.5-123.8c-0.1,0-0.2,0-0.3-0.1l-4.2-2.1c-0.3-0.1-0.4-0.4-0.4-0.7v-6.2c0-0.4,0.3-0.8,0.8-0.8 s0.8,0.3,0.8,0.8v5.8l3.7,1.9c0.4,0.2,0.5,0.6,0.3,1C-1220-124-1220.2-123.8-1220.5-123.8z"
}))));

function SvgTimeZone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeZone);
export default __webpack_public_path__ + "static/media/time_zone.82a70a2a.svg";
export { ForwardRef as ReactComponent };